import {merge} from "lodash";
import deepCamelizeKeys from "../utils/object/deepCamelizeKeys.js";
import deepSnakeizeKeys from "../utils/object/deepSnakeizeKeys.js";


function isFormData(value) {
  return value instanceof FormData;
}

const stringifyBody = (data) => {
  try {
    return JSON.stringify(deepSnakeizeKeys(data));
  } catch (error) {
    console.error('Error stringifying body:', error);
    return null;
  }
}

const fetchJSON = async (url, method = 'GET', options = {}, data = {}) => {
  const headers = merge({
    'Accept': 'application/json',
  }, isFormData(data) ? {} : { 'Content-Type': 'application/json' }, options.headers || {});

  const body = isFormData(data) ? data : (method !== 'GET' ? stringifyBody(data) : undefined);

  try {
    const response = await fetch(url, {
      method,
      headers,
      body,
    });

    if (!response.ok) {
      const error = new Error(`HTTP error! status: ${response.status}`)
      error.status = response.status
      try {
        const errorBody = await response.json()
        error.data = deepCamelizeKeys(errorBody)
      } catch (_) {
        // response body not JSON
      }
      throw error
    }

    if (response.status === 204 || response.headers.get('content-length') === '0') {
      return {};
    }

    const text = await response.text();
    if (!text) {
      return {};
    }

    return deepCamelizeKeys(JSON.parse(text));
  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
  }
};

export default fetchJSON;
